package com.essntl.features.tag.ui.alltags

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.tag.domain.model.TagModel

data class AllTagsState(
    val getAllTags: State<List<TagModel>> = State(),
)
